import iOSMessageHandler from "shared/ios_message_handler"

export default function() {
  // We ensure that it's within the iOS app by checking that the injected pushNotifications handler is available.
  return new iOSMessageHandler().isPushChannelAvailable()
}
